import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-diners-card-display',
  templateUrl: './diners-card-display.component.html',
  styleUrls: ['./diners-card-display.component.scss']
})
export class DinersCardDisplayComponent {
  @Input() cardNumber: string = 'XXXX XXXX XXXX XXXX'
  @Input() expirationDate: string = 'MM/YY'
  @Input() cardName: string = 'NOMBRE Y APELLIDO'
  @Input() cvv: string = 'XXX'
}
